export enum PortLayoutType {
	Icon = 1,
	Card = 2,
}
